<template>
  <div>
<!--    <div>-->
<!--    <div class="remington-typed-font full-height text-align-center">-->
<!--      <div class="inline-block margin-auto width-90 full-height vertical-middle">-->
<!--        <nav class="navigationList inline-block">-->
<!--          <ul>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li>&lt;!&ndash;              <li>|</li>&ndash;&gt;-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>-->
<!--          </ul>-->
<!--        </nav>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>TEAMSPEAK RADIO COMMUNICATIONS</h1>
    </div>
    <br>
    <br>
    <div class="">
      <p class="text-align-left">
        For our Campaign, we make use of <a href="https://www.teamspeak.com/en/downloads/">Teamspeak 3</a>as our main mode of communications.
        In order to take part therefore, you must have Teamspeak 3 installed on your computer.
        This software allows us to quite accurately re-create the radio communication conditions that were present during any period of World War 2.
      </p>
      <p class="text-align-left">
        To download and install Teamspeak 3, please follow the <a href="https://www.teamspeak.com/en/support/get-started/">instructions</a>that can be found on the Teamspeak website.
      </p>
      <p class="text-align-left">
        To connect to our server, go to Connections -> Connect, enter the server address and password and your nickname.
      </p>
      <p class="text-align-left">
        Once connected you will be able to see the channel structure of our server.
        This is divided into several general use channels at the top of the list, followed by our Campaign channels below.
        These are set up to reflect the radio capabilities of the aircraft fitted in the current Campaign.
        For instance, the RAF channels are usually three, A, B, and C, followed by a number of D channels.
        This reflects the fact that RAF aircraft were fitted radios that could switch between four pre-determined radio frequencies, which were programmed by the ground crew.
      </p>
      <p class="text-align-left">
        Naturally, you will need to be able to switch between these frequencies (channels) while in flight, and preferably without having to tab out of the game to switch the Teamspeak channels.
      </p>
      <h2>How to set up your Teamspeak to be Push-To-Talk (PTT)</h2>
      <p class="text-align-left">
        You wil have to set a key with which to activate your microphone.
      </p>
      <p class="text-align-left">
      To do that navigate to Tools -> Options and select Capture in the list that appears on the left.
      Then under Activate, select Push-To-Talk and enter the keypress you want to use in order to talk.
      </p>
      <h2>How to set up your Teamspeak radio channels for the Campaign</h2>
      <p class="text-align-left">
        To set up your channels, you will need to assign hotkeys to the action of switching Teamspeak channels.
      </p>
      <ul style="margin-left: 2em">
        <li>Navigate to Tools -> Options.</li>
        <li>Select Hotkeys from the left hand list that appears.</li>
        <li>Click Add at the bottom of the window. It is the button with the green Plus sign.</li>
        <li>Select Show Advanced Actions. This will display more options than previously available.</li>
        <li>All the different types of Actions that you can set with hotkeys is displayed.</li>
        <li>Select Switch to Channel and then Switch to Channel again.</li>
        <li>Click the channel that you want to set a hotkey for.</li>
        <li>Select On Current Server to specify that you want to set the server for which this hotkey is active.</li>
        <li>Enter the key that you want to assign this action to.</li>
        <li>The OK button will now become clickable and this will add and activate the hotkey.</li>
        <li>Do the same for the other channels that you will need to switch to.</li>
      </ul>
      <br>
      <iframe style="margin-left: 10em; border-radius: 25px" id="ytplayer" type="text/html" width="49%" height="150px" src="https://www.youtube.com/embed/vSs20-Fwbko"
              frameborder="0"></iframe>
      <h2>IMMERSION RECOMMENDATIONS</h2>
      <p class="text-align-left">
        In order to make the experience more immersive and intense for yourself and your squadron mates, we recommend that you use the brilliant <a href="https://www.myteamspeak.com/addons/f2e04859-d0db-489b-a781-19c2fab29def">Radio FX</a> plugin.
        This makes all Teamspeak communications sound as if they were transmitted over a radio.
      </p>
      <p class="text-align-left">
        Furthermore, we recommend that you disable Teamspeak notifications so that your experience can be as smooth as possible, without the constant intrusions of "User entered your channel".
        This can be done from the Tools -> Options -> Notifications menu. From the drop down menu under Sound Pack at the top of the window, select Sounds Deactivated.
      </p>
      <p class="text-align-left">
        We also recommend that if you are killed, seriously wounded or your plane suffers heavy damage, that you do not state so over the radio.
        There is nothing so immersive as to lose radio contact with a squadron mate, only to find out later that they were shot down and had to bail out.
        This limits the information available to your fellow pilots and makes for a more fun and challenging experience for all.
      </p>
    </div>
  </div>
  </div>
</template>

<script>

  import LinkButton from "../basic_comp/LinkButton";
  export default {
    name: "CommunicationsSetup",
    components: {LinkButton}
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/CommunicationsSetup.vue